
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Numpad extends Vue {
    @VModel() input!: string;
    @Prop({ default: 0 }) minLength!: number;
    @Prop({ default: 0 }) maxLength!: number;
    @Prop({ default: false }) validated!: boolean;

    protected numpadLayout: string[][] = [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
        ['Back', '0', 'OK'],
    ];

    protected handleButtonClick(key: string): void {
        let input = this.input;
        if (!this.isEnabledButton(key)) {
            return;
        }
        if (key === 'Back') {
            if (input.length > 0) {
                input = input.slice(0, input.length - 1);
                this.$emit('input', input);
            }
            else {
                this.$emit("clear");
            }
        } else if (key === 'OK') {
            this.submitInput();
        } else {
            if (this.input.length < this.maxLength) {
                input += key;
                this.$emit('input', input);
                if (input.length == this.maxLength) {
                    this.$emit("filled");
                }
            }
        }
    }

    protected submitInput(): void {
        if (!this.validated) {
            this.$emit('submit', this.input);
        }
    }

    protected isActionButton(key: string): boolean {
        return key === 'Back' || key === 'OK';
    }

    protected isEnabledButton(key: string): boolean {
        if (key == 'OK') {
            return this.input.length >= this.minLength;
        } else if (key == 'Back') {
            return !this.validated;
        } else {
            return !this.validated && this.input.length < this.maxLength;
        }
    }
}
